import { render, staticRenderFns } from "./Tariff.vue?vue&type=template&id=f984120a&scoped=true"
import script from "./Tariff.vue?vue&type=script&lang=js"
export * from "./Tariff.vue?vue&type=script&lang=js"
import style0 from "./Tariff.vue?vue&type=style&index=0&id=f984120a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f984120a",
  null
  
)

export default component.exports